var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"admin-view"},[(_vm.$route.params.id)?_c('BackButton'):_vm._e(),_c('section',{staticClass:"admin-child"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }